import "../css/style.scss"

import $ from 'jquery';

// Our modules / classes
import GoogleMap from "./modules/GoogleMap";
import TeamBio from "./modules/TeamBio";
import FAQ from "./modules/Faqs";
import FeeAccordion from "./modules/Fees";
import Headroom from "./modules/Headroom";
import MenuHover from "./modules/MenuHover";

// standard function components
import "./modules/BeforeAfter";
import "./modules/Lazyload";
import "./modules/BurgerMenu";
import "./modules/Checkbox";
import "./modules/AdobeFont";
import "./modules/Gallery";
import "./modules/slick";

// Instantiate a new object using our modules/classes
const googleMap = new GoogleMap();
const teamBio = new TeamBio();
const faq = new FAQ();
const feeAccordion = new FeeAccordion();
const menu = new MenuHover();

// call any auxillary functions
(function() {

    // check if headroom works on the browser and then add sticky to the navigation
    if (Headroom.cutsTheMustard) {
        // scroll depth before function kicks in and hides nav. Stops bug where if someone nudges their mouse to scroll, navigation disappears even if the scroll depth is a few px
        const options = {
            offset : 0
        }

        const stickyNav = new Headroom(document.querySelector('.headroom-nav'), options);

        stickyNav.init();
    }

    // slick initalise
    $('.slick-fade').slick({
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 2500,
        draggable: true,
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'linear'
    });

    // Initialize Slick on the content slider
    $('.content-slider').slick({
        dots: true,
        arrows: false,
        infinite: false,
        speed: 500,
        variableWidth: true,
        focusOnSelect: true,
        slidesToShow: 1,
        slidesToScroll: 1
    });

    $('#footer-logo-slider').slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 1000,
        responsive: [
            {
                breakpoint: 1600,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 1260,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 976,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 590,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });
})();